import { Col, Flex, Typography } from "antd"
import React from "react"

const { Text } = Typography

interface Props {
  label: string
  value?: React.ReactNode
  /** What to show when the value is absent; neutral, never an error. */
  emptyText: string
  xs?: number
  sm?: number
  md?: number
}

/**
 * A compact read-only label/value pair, the label directly above its value.
 * Always renders, falling back to the neutral placeholder, so a section's
 * shape never shifts depending on what the record happens to have.
 */
export const DetailField = ({
  label,
  value,
  emptyText,
  xs = 24,
  sm,
  md = 12
}: Props) => (
  <Col xs={xs} sm={sm} md={md}>
    <Flex vertical gap={6}>
      <Text
        type={"secondary"}
        className={"break-words text-[13px] leading-snug"}
      >
        {label}
      </Text>
      {value ? (
        <Text className={"break-words text-[15px] leading-normal"}>
          {value}
        </Text>
      ) : (
        <Text
          type={"secondary"}
          className={"break-words text-[15px] leading-normal"}
        >
          {emptyText}
        </Text>
      )}
    </Flex>
  </Col>
)
